/* import __COLOCATED_TEMPLATE__ from './follow-up-reply.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();